import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './appRastreioForm';
import Aguardando from '../common/template/aguardando';

import { setModoTela, initForm, salvar, excluir, getLista } from './appRastreioActions';
import DateFormat from '../common/dateFormat/DateFormat';
import { MapLeaflet } from '../common/mapLeaflet/MapLeaflet';
import Select from '../common/form/select';
import ContentCardFooter from '../common/template/contentCardFooter';
import LabelAndInputMask from '../common/form/labelAndInputMask';

class AppRastreio extends Component {

	state = {
		linhaSelecionada: null,
		data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual()),
		data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
	}

    componentWillMount() {
		this.props.getLista();

		this.idIntervalAtualizacao = setInterval(() => {
			this.props.getLista();
		}, 120000)
    }

	componentWillUnmount() {
		clearInterval(this.idIntervalAtualizacao);
	}

    render() {
        return (
            <div>
                <Content>

					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<ContentCardBody>
					<Table responsive>
						<THead>
							<Tr>
								<Th>Usuário</Th>
								<Th alignCenter>Data/Hora</Th>
								<Th alignCenter>Posição</Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.lista.map(item => (
								<Tr key={item.id} >
									<Td>{item.nome_usuario}</Td>
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_posicao)}</Td>
									<Td alignCenter><a href={`https://www.google.com/maps/place/${item.latitude},${item.longitude}`} target='blank'>{item.latitude}, {item.longitude}</a></Td>
								</Tr>
							))}
						</TBody>
					</Table>
					<Row style={{ marginTop: 20 }}>
						<Grid cols='12 12 12 12'>
							<div style={{ width: '100%', height: 600 }}>
								<MapLeaflet
									coordenadas={this.props.lista.map(item => ({
											id: item.id,
											titulo: item.nome_usuario,
											latitude: item.latitude,
											longitude: item.longitude,
											direcao: 'N'
										}))}
									zoom={12}
									latitude={'-28.389116'}
									longitude={'-53.915845'}
									onChange={(coordenadas) => {
									}}
								/>
							</div>
						</Grid>
					</Row>
				</ContentCardBody>

				<ContentCardFooter>
					<Row style={{ marginTop: 16 }}>
						<Select
							label='Usuário'
							options={this.props.lista.map(item => ({ id: item.id, valor: item.nome_usuario }))}
							cols='12 6 4 4'
							placeholder='Selecione'
							value={this.state.id_filtro}
							onChange={value => {
								this.setState({ ...this.state, id_filtro: value });
							}} />

						<LabelAndInputMask
							label='Data Inicial' placeholder='Informe a data'
							cols='12 6 2 1'
							mask='99/99/9999'
							minWidth={130}
							maxWidth={130}
							value={this.state.data_inicial}
							onChange={data => {
								this.setState({ ...this.state, data_inicial: data.target.value });
							}} />
							
						<LabelAndInputMask
							label='Data Final' placeholder='Informe a data'
							cols='12 6 2 1'
							mask='99/99/9999'
							minWidth={130}
							maxWidth={130}
							value={this.state.data_final}
							onChange={data => {
								this.setState({ ...this.state, data_final: data.target.value });
							}} />
					</Row>
					
					<Table responsive>
						<THead>
							<Tr>
								<Th>Usuário</Th>
								<Th alignCenter>Data/Hora</Th>
								<Th alignCenter>Evento</Th>
								<Th alignCenter>Posição</Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista.filter(item => item.id == this.state.id_filtro)[0] 
								? (this.props.lista.filter(item => item.id == this.state.id_filtro)[0].lista_historico || [])
									.filter(historico => {
										if (!historico) {
											return true;
										}
										
										const data = DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(historico.datahora_posicao));

										return DateFormat.formatarDataTelaParaSql(this.state.data_inicial) <= data 
											&& DateFormat.formatarDataTelaParaSql(this.state.data_final) >= data
									}) 
								: []
							).map(item => (
								<Tr key={item.id} >
									<Td>{item.descricao ? item.nome_usuario : ''}</Td>
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_posicao)}</Td>
									<Td alignCenter>{item.descricao || 'Posição'}</Td>
									<Td alignCenter><a href={`https://www.google.com/maps/place/${item.latitude},${item.longitude}`} target='blank'>{item.latitude}, {item.longitude}</a></Td>
								</Tr>
							))}
						</TBody>
					</Table>

				</ContentCardFooter>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.appRastreio.modoTela,
	aguardando: state.appRastreio.aguardando,
	lista: state.appRastreio.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvar, excluir, getLista }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(AppRastreio);
